import React from "react";

import CsvImportModal from "Components/Common/CsvImport/CsvImportModal";
import { importGovtRequests } from "common/services/govt-requests.service";
import {
  GOVERNMENT_REQUEST_IMPORT_FIELDS,
  mapGovernmentRequestImportRow,
} from "./governmentRequestImportConfig";

const GovernmentRequestsImportModal: React.FC<{
  isOpen: boolean;
  toggle: () => void;
  onImported?: () => void;
}> = ({ isOpen, toggle, onImported }) => (
  <CsvImportModal
    isOpen={isOpen}
    toggle={toggle}
    title="Import Government Requests"
    subtitle="Upload a CSV file to bulk-import government request records"
    icon="ri-government-line"
    fields={GOVERNMENT_REQUEST_IMPORT_FIELDS}
    mapRow={mapGovernmentRequestImportRow}
    importRecords={importGovtRequests}
    templatePath={`${process.env.PUBLIC_URL}/templates/government_requests_import_template.csv`}
    templateFileName="government_requests_import_template.csv"
    failedFileName="Failed_Government_Requests_Import.csv"
    recordLabel="government request"
    onImported={onImported}
  />
);

export default GovernmentRequestsImportModal;
